module.exports = __webpack_public_path__ + "img/rating-forbes.8d78b623.webp";